import { FILTERS } from '~/const';
import { useTenantContext } from '~/context/TenantProvider';
import { useUserInfoContext } from '~/context/UserInfoProvider';
import { ContentStrategy, Maybe } from '~/types';

const useAlgoliaIndexFilter = (additionalFilter: Maybe<string>) => {
  const { tenant } = useTenantContext();
  const { suiteIDs, userInfo } = useUserInfoContext();
  const companyId = userInfo?.company?.id;
  const strategy = userInfo?.company?.content_strategy || ContentStrategy.Default;
  const tenantID = typeof tenant?.id === 'string' ? tenant.id : null;

  if (!tenantID) {
    return;
  }

  // when we have suiteIDs - that means that we're logged in and this is use with suites
  const sanitizedSuiteIds = suiteIDs.length > 0 ? suiteIDs : [tenantID];

  const tenantFilter = `${FILTERS.Tenants}:${tenantID}`;
  const suitesFilter = sanitizedSuiteIds.map((value) => `${FILTERS.Suites}:${value}`).join(` OR `);
  const baseContentFilter = `(${tenantFilter} OR ${suitesFilter}) AND NOT ${FILTERS.Bespoke}:true`;
  const allowedFilter = `${FILTERS.AllowedCompanyIds}:${companyId}`;
  const restrictedFilter = `${FILTERS.RestrictedCompanyIds}:${companyId}`;

  const strategies = {
    [ContentStrategy.Default]: baseContentFilter,
    [ContentStrategy.Allow]: `${baseContentFilter} OR ${allowedFilter}`,
    [ContentStrategy.AllowOnly]: `${allowedFilter}`,
    [ContentStrategy.Restrict]: `${baseContentFilter} AND NOT ${restrictedFilter}`,
    [ContentStrategy.AllowRestrict]: `${baseContentFilter} OR ${allowedFilter} AND NOT ${restrictedFilter}`,
  };

  // for an existing users and logged out state - use the same query
  return [additionalFilter && `(${additionalFilter})`, strategies[strategy]]
    .filter(Boolean)
    .join(' AND ');
};

export default useAlgoliaIndexFilter;
